import { render, staticRenderFns } from "./DepositCardPopup.vue?vue&type=template&id=4e1787fd&"
import script from "./DepositCardPopup.vue?vue&type=script&lang=js&"
export * from "./DepositCardPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports